import { InteractableTriggerTypes } from 'common/builder/constants/InteractableTriggerTypes'
import { TriggerType } from 'common/flow/constants/TriggerType'
import { IFlowTrigger } from 'common/flow/flowInterfaces'

export const isTriggerInteractive = (trigger: IFlowTrigger): boolean => {
  const { triggerType } = trigger

  const isKeywordReservedTrigger =
    trigger.triggerType === TriggerType.KEYWORD && trigger.is_reserved

  return InteractableTriggerTypes.includes(triggerType) && !isKeywordReservedTrigger
}
